import { useQuery } from '@tanstack/react-query';

import { QUERY_KEY } from '~common';
import { getPaymentRequest } from '~services';
import { inMemoryJWTService } from '~services/jwt.service';
import { CampusCardBalanceResponse } from '~types';

export const useQueryGetCampusCardBalance = (cardId?: string) => {
  return useQuery<CampusCardBalanceResponse>(
    [QUERY_KEY.GET_CAMPUS_CARD_BALANCE, cardId],
    () =>
      getPaymentRequest<CampusCardBalanceResponse>({
        path: `api/campus-card/balance/${cardId}`,
      }),
    {
      enabled: !!cardId && !!inMemoryJWTService.getCurrentToken(),
    },
  );
};
